<div class="attribute-title">Show property measurement units in:</div>
<div class="inline-attribute units-radio-buttons">
  <mat-radio-group class="type-radio-group" [value]="measurementSystem" (change)="onMeasurementSystemChange($event)">
    <mat-radio-button [value]="measurementSystems.IMPERIAL">Imperial</mat-radio-button>
    <span class="spacer auth-option-spacer"></span>
    <mat-radio-button [value]="measurementSystems.METRIC">Metric</mat-radio-button>
  </mat-radio-group>
</div>

<div class="inline-attribute">
  <div class="checkbox-div">
    <mat-checkbox
      [checked]="visibilityValues?.propertyFootprint"
      (change)="onVisibilityChange('propertyFootprint', $event.checked)"
      [disabled]="discreteEnabled"
      class="footprint-checkbox">
      Show property footprints
    </mat-checkbox>
    <mat-checkbox
      [checked]="visibilityValues?.labelsFootprint"
      (change)="onVisibilityChange('labelsFootprint', $event.checked)"
      [disabled]="discreteEnabled"
      class="footprint-checkbox">
      Show building labels
    </mat-checkbox>
  </div>
</div>
